import React from 'react'
import { Wallet } from '../../../../types/wallet.types';
import { dateConverter } from '../../../../../../utils/dateConverter';
import { useSingleWallet } from '../../../../hooks/useWallet';
import { numberFormaterString } from '../../../../../../utils/numberFormater';




export interface WalletInfoProps {
  info: keyof Wallet ;
  id?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    item?: unknown;
    value?: unknown;

    goTo: () => void;
  }) => JSX.Element;
}

export default function WalletsInfo({info, id, emptyText, renderComponent}: WalletInfoProps) {

    const { singleWalletQuery } = useSingleWallet(id);

  

    if (singleWalletQuery.isLoading) return <>...</>;
    if (singleWalletQuery.isError) return <>{emptyText || "-"}</>;

    const convertValue = (info: keyof Wallet , value: any) => {
      switch (info) {
        case "wallet_created_at":
          return dateConverter(value);
        case "wallet_amount":
          return numberFormaterString(value);
        case "wallet_pending_amount":
          return numberFormaterString(value);
        default:
          return value;
      }
    };

    if (renderComponent) {
      return renderComponent({
        labelRender: convertValue(info, singleWalletQuery?.data?.[info]),
        item: singleWalletQuery?.data,
        value: singleWalletQuery?.data?.[info],
        goTo: () => {},
      });
    }



  return (
    <>
      {convertValue(info, singleWalletQuery?.data?.[info])}
    </>
  )
}
